import React from 'react';
import {Heading, Box, VStack, HStack, Text, View} from 'native-base';
import {message} from '../../../../../utils/messages';
import {BolivarIcon, DollarIcon} from '../../../../../components/icons';
import {CurrencyType} from '../../../../../constants/enumerations';
import {StyleProp, TextStyle} from 'react-native';
import {
  ColorSchemeType,
  ResponsiveValue,
} from 'native-base/lib/typescript/components/types';
import {ILinearGradientProps} from 'native-base/lib/typescript/components/primitives/Box/types';

interface ISectionProps {
  currency: CurrencyType;
  total: string;
  paidOut: string;
  balance: string;
  style?: StyleProp<TextStyle>;
  backgroundColor?: ResponsiveValue<ColorSchemeType | ILinearGradientProps>;
}

const DetailSection = (props: ISectionProps) => {
  const {currency, total, paidOut, balance, style, backgroundColor} = props;

  const Currency = () => {
    if (currency === CurrencyType.foreign) {
      return <DollarIcon />;
    }
    return <BolivarIcon />;
  };

  const Title = () => {
    return (
      <Heading size="sm" fontWeight="medium" color="#4C4C4C">
        {currency === CurrencyType.foreign
          ? message('balance-detail-foreign-value-label')
          : message('balance-detail-local-value-label')}
      </Heading>
    );
  };

  return (
    <Box
      backgroundColor={backgroundColor ?? '#FFFFFF'}
      paddingX={8}
      flex={1}
      style={style}
      paddingY={3}>
      <Heading size="sm" fontWeight="medium" color="#4C4C4C">
        <Title />
      </Heading>
      <VStack paddingLeft={3} marginTop={3}>
        <HStack space={5}>
          <VStack justifyContent="center" space="0" flex={1}>
            <Box justifyContent="center">
              <Text color="#99A2B4" fontSize={'16'} numberOfLines={3}>
                {message('detail-section-total')}
              </Text>
            </Box>
          </VStack>
          <HStack w="110" justifyContent="center">
            <VStack justifyContent="center" space="1">
              <Box height="6" justifyContent="center">
                <Currency />
              </Box>
            </VStack>
            <VStack space="1" w={'110'} justifyContent="center">
              <View
                height="6"
                alignItems="flex-end"
                paddingLeft="2"
                justifyContent="center">
                <Text fontWeight="bold" color="#06355E" fontSize="lg">
                  {total}
                </Text>
              </View>
            </VStack>
          </HStack>
        </HStack>
        <HStack space={5} marginTop={2}>
          <VStack justifyContent="center" space="0" flex={1}>
            <Box justifyContent="center">
              <Text color="#99A2B4" fontSize={'16'} numberOfLines={3}>
                {message('detail-section-payd-out')}
              </Text>
            </Box>
          </VStack>
          <HStack w="110" justifyContent="center">
            <VStack justifyContent="center" space="1">
              <Box height="6" justifyContent="center">
                <Currency />
              </Box>
            </VStack>
            <VStack space="1" w={'110'} justifyContent="center">
              <View
                height="6"
                alignItems="flex-end"
                paddingLeft="2"
                justifyContent="center">
                <Text fontWeight="bold" color="#06355E" fontSize="lg">
                  {paidOut}
                </Text>
              </View>
            </VStack>
          </HStack>
        </HStack>
        <HStack space={5} marginTop={2}>
          <VStack justifyContent="center" space="0" flex={1}>
            <Box justifyContent="center">
              <Text color="#99A2B4" fontSize={'16'} numberOfLines={3}>
                {message('detail-section-balance')}
              </Text>
            </Box>
          </VStack>
          <HStack w="110" justifyContent="center">
            <VStack justifyContent="center" space="1">
              <Box height="6" justifyContent="center">
                <Currency />
              </Box>
            </VStack>
            <VStack space="1" w={'110'} justifyContent="center">
              <View
                height="6"
                alignItems="flex-end"
                paddingLeft="2"
                justifyContent="center">
                <Text fontWeight="bold" color="#06355E" fontSize="lg">
                  {balance}
                </Text>
              </View>
            </VStack>
          </HStack>
        </HStack>
      </VStack>
    </Box>
  );
};
export default DetailSection;
